
import Image from "next/image";
import { publicAsset } from "@/lib/public-assets";
// import { BetaIcon } from "@/components/fun-ui/icons";

export function SiteLogo({
  size = 33,
}: { size?: number }) {
  return (
    <span className="text-sm sm:text-2xl flex items-center justify-between space-x-2 ml-4 h-5 sm:h-auto">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img className="h-full w-auto" alt="findin 飞引" src={publicAsset("/logo-full.svg")} width={size} height={size / 30 * 183} />
      <span className="sr-only">Findin 飞引</span>
    </span>
  )
}

type DashboardLogoProps = {
  iconOnly: boolean;
}
export function DashboardLogo({
  iconOnly = false,
}: DashboardLogoProps) {
  return (
    <>
      {
        iconOnly ? (
          <Image alt="findin" src={publicAsset("/logo-findin.svg")} width={22} height={22} priority />
        ) : (
          <Image alt="findin" src={publicAsset("/logo-full.svg")} width={152.5} height={25} priority />
        )
      }
    </>
  )
}
